import React from 'react';
import type { Section, SortKey } from './invoicesViewShared';

/**
 * Spaltenkopf, der sortiert.
 *
 * Erster Klick sortiert absteigend — bei Betraegen und Daten ist das die
 * Frage, die man stellt ("wo ist am meisten offen", "was ist das Neueste").
 * Aufsteigend erreicht man mit dem zweiten Klick.
 */
export const SortableTh: React.FC<{
    sortKey: SortKey;
    sort: { key: SortKey; dir: 'asc' | 'desc' };
    onSort: (s: { key: SortKey; dir: 'asc' | 'desc' }) => void;
    right?: boolean;
    children: React.ReactNode;
}> = ({ sortKey, sort, onSort, right, children }) => {
    const active = sort.key === sortKey;
    return (
        <th className={`px-5 py-4 ${right ? 'text-right' : ''}`}>
            <button
                type="button"
                onClick={() =>
                    onSort({
                        key: sortKey,
                        dir: active && sort.dir === 'desc' ? 'asc' : 'desc',
                    })
                }
                className={`inline-flex items-center gap-1 uppercase tracking-wider transition-colors hover:text-slate-700 ${
                    active ? 'text-slate-700' : ''
                }`}
            >
                {children}
                <span className={active ? 'opacity-100' : 'opacity-0'}>
                    {sort.dir === 'desc' ? '▾' : '▴'}
                </span>
            </button>
        </th>
    );
};

export const SectionTabs: React.FC<{
    section: Section;
    onChange: (s: Section) => void;
    /** Fehlt das Recht auf die Buchhaltung: der Reiter steht gesperrt mit diesem Titel. */
    buchhaltungGesperrt?: string;
}> = ({ section, onChange, buchhaltungGesperrt }) => (
    <div data-glass="reiter" className="flex gap-2">
        {(
            [
                ['documents', 'Belege'],
                ['accounting', 'Buchhaltung'],
            ] as Array<[Section, string]>
        ).map(([key, label]) => (
            <button
                key={key}
                type="button"
                onClick={() => onChange(key)}
                disabled={key === 'accounting' && buchhaltungGesperrt !== undefined}
                title={key === 'accounting' ? buchhaltungGesperrt : undefined}
                className={`rounded-xl border px-4 py-2 text-sm font-bold transition-all disabled:cursor-not-allowed disabled:opacity-50 ${
                    section === key
                        ? 'border-indigo-200 bg-white text-indigo-600 shadow-sm'
                        : 'border-transparent bg-slate-50 text-slate-500 hover:border-slate-200 hover:bg-white'
                }`}
            >
                {label}
            </button>
        ))}
    </div>
);
